import { DevTool } from "@hookform/devtools";
import { FormProvider } from "react-hook-form";
import { Create, Edit } from "@refinedev/mui";
import { FormContainer } from "react-hook-form-mui";
import { Typography, Box } from "@mui/material";
import { useResource } from "@refinedev/core";
import { firstLetterToUpperCaseAndRemoveLastLetter } from "@/utils/text-transform";
import FormErrorDisplayer from "../form/ErrorMessageDisplayer";

export const CreateOrEdit = ({
  actionType,
  formValues,
  children,
  handleSubmit,
  title,
  hideButtons = false
}: {
  actionType: "create" | "edit";
  formValues: any;
  children: React.ReactNode;
  handleSubmit?: (event: React.FormEvent) => void;
  title?: {
    create?: string;
    edit?: string;
  };
  hideButtons?: boolean;
}) => {
  const { resource } = useResource();
  const saveButtonProps = handleSubmit
    ? { ...formValues.saveButtonProps, onClick: handleSubmit }
    : formValues.saveButtonProps;

  const id = formValues.getValues?.()?.id;
  const derivedTitle = title?.edit || `Edit ${firstLetterToUpperCaseAndRemoveLastLetter(resource?.name)} #${id}`;  

  // CSS to hide buttons
  const hideButtonsStyle = hideButtons ? {
    sx: {
      // Hide all navigation buttons in the header
      '& .MuiCardHeader-action': {
        display: 'none'
      },
      '& .refine-save-button': {
        display: 'none'
      }
    }
  } : {};

  return (
    <FormContainer>
      <FormProvider {...formValues}>
        {import.meta.env.DEV && <DevTool control={formValues.control} />}
        <Box {...hideButtonsStyle} >
          {actionType === "create" ? (
            <Create 
              saveButtonProps={saveButtonProps}
              headerProps={title?.create ? { title: <Typography variant="h5">{title?.create}</Typography> } : undefined}
              goBack={hideButtons ? false : undefined}
              contentProps={{sx: {m: 0, p: 0}}}
            >
              {children}
              <FormErrorDisplayer />
            </Create>
          ) : (
            <Edit 
              headerProps={{ title: <Typography variant="h5">{derivedTitle}</Typography> }}
              saveButtonProps={saveButtonProps}
              goBack={hideButtons ? false : undefined}
            >
              {children}   
              <FormErrorDisplayer />
            </Edit>
          )}
        </Box>
      </FormProvider>
    </FormContainer>
  );
};